import React from 'react'
import Header from './Header'
import { Outlet } from 'react-router-dom'

const CustomerLayout = () => {
  return (
    <div className="main-page">
      <Header />
      <div data-bs-spy="scroll" className="scrollspy-example">
        <Outlet />
      </div>
    </div>
  )
}

export default CustomerLayout